import React, { useContext } from "react";

export class VirtualReference {
    getBoundingClientRect() {
        const height = 200;
        const width = 350;
        return {
            top: (document.body.clientHeight - height) / 2,
            left: (document.body.clientWidth - width) / 2,
            bottom: (document.body.clientHeight - height) / 2,
            right: (document.body.clientWidth - width) / 2,
            width: 0,
            height: 0,
        };
    }

    get clientWidth() {
        return this.getBoundingClientRect().width;
    }

    get clientHeight() {
        return this.getBoundingClientRect().height;
    }
}

const virtualReferenceElement = new VirtualReference();

export type PopupContext = {
    getReferenceRef: (el: HTMLElement | undefined, user: UserIdentification | undefined) => void;
    referenceNode?: HTMLElement;
    user?: UserIdentification;
};

type ManagerState = {
    context: PopupContext;
};

const defaultValue: PopupContext = {
    getReferenceRef: () => {},
    referenceNode: undefined,
    user: undefined,
};

export class PopupProvider extends React.Component<{}, ManagerState> {
    private getReferenceRef = (
        referenceNode: HTMLElement | undefined,
        user: UserIdentification | undefined
    ) =>
        this.setState(({ context }) => ({
            context: { ...context, referenceNode, user },
        }));
    public state = {
        context: {
            ...defaultValue,
            getReferenceRef: this.getReferenceRef,
        },
    };

    public render() {
        return (
            <ManagerContext.Provider value={this.state.context}>
                {this.props.children}
            </ManagerContext.Provider>
        );
    }
}

export const ManagerContext = React.createContext<PopupContext>(defaultValue);

export function usePopupUserAndRerefence() {
    const context = useContext(ManagerContext);
    if (!context.user) {
        return;
    }
    return {
        user: context.user,
        referenceElement: context.referenceNode || virtualReferenceElement,
    };
}

export type UserIdentification =
    | { type: "room"; roomId: string }
    | { type: "user"; userId: string };
interface PopupReferenceOnClickCommonProps {
    user: UserIdentification;
    children: (props: {
        ref: React.RefObject<HTMLDivElement>;
        onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
    }) => React.ReactNode;
}

export function PopupReferenceOnClick(props: PopupReferenceOnClickCommonProps) {
    const context = useContext(ManagerContext);
    return (
        <PopupReferenceOnClickInner user={props.user} ctx={context}>
            {props.children}
        </PopupReferenceOnClickInner>
    );
}

function isClickInsideDropdown(e: MouseEvent) {
    const dropdown = document.getElementsByClassName("UserInfoPopup").item(0);
    let el = e.srcElement as HTMLElement | null;
    while (el) {
        if (el === dropdown) {
            return true;
        }
        el = el.parentElement;
    }
    return false;
}

export class PopupReferenceOnClickInner extends React.PureComponent<
    PopupReferenceOnClickCommonProps & { ctx: PopupContext }
> {
    private onClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        const { getReferenceRef } = this.props.ctx;
        if (this.props.ctx.referenceNode === this.ref.current) {
            return;
        }
        setTimeout(() => {
            getReferenceRef(this.ref.current || undefined, this.props.user);
        });
        const fn = (e: MouseEvent) => {
            if (isClickInsideDropdown(e)) {
                return;
            }
            getReferenceRef(undefined, undefined);
            document.removeEventListener("click", fn);
        };
        document.addEventListener("click", fn);
    };
    private ref = React.createRef<HTMLDivElement>();
    public render() {
        return this.props.children({
            ref: this.ref,
            onClick: this.onClick,
        });
    }
}
